module.exports = __webpack_public_path__ + "media/images/icons/outlined/pic-left-62d0888debf8c959f6d6eb05441e30ea.svg";